const genres = [
    {
        "id": 10759,
        "name": "Ação e Aventura"
    },
    {
        "id": 16,
        "name": "Animação"
    },
    {
        "id": 35,
        "name": "Comédia"
    },
    {
        "id": 80,
        "name": "Crime"
    },
    {
        "id": 99,
        "name": "Documentário"
    },
    {
        "id": 18,
        "name": "Drama"
    },
    {
        "id": 10751,
        "name": "Família"
    },
    {
        "id": 10762,
        "name": "Crianças"
    },
    {
        "id": 9648,
        "name": "Mistério"
    },
    {
        "id": 10763,
        "name": "Notícias"
    },
    {
        "id": 10764,
        "name": "Realidade"
    },
    {
        "id": 10765,
        "name": "Ficção Científica e Fantasia"
    },
    {
        "id": 10766,
        "name": "Telenovela"
    },
    {
        "id": 10767,
        "name": "Talk Show"
    },
    {
        "id": 10768,
        "name": "Guerra e Política"
    },
    {
        "id": 37,
        "name": "Faroeste"
    },
    {
        "id": 14,
        "name": "Fantasia"
    },
    {
        "id": 36,
        "name": "História"
    },
    {
        "id": 27,
        "name": "Terror"
    },
    {
        "id": 10402,
        "name": "Música"
    },
    {
        "id": 10749,
        "name": "Romance"
    },
    {
        "id": 878,
        "name": "Ficção Científica"
    },
    {
        "id": 10770,
        "name": "Filme para TV"
    },
    {
        "id": 53,
        "name": "Suspense"
    },
    {
        "id": 10752,
        "name": "Guerra"
    }
]

export default genres;